import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import { useQuery } from '@tanstack/react-query';

function useEasyCards(isInitialPinSetting?: boolean) {
    const { data, isLoading } = useQuery({
        ...kiccEasyCardQueries.list(),
        enabled: !isInitialPinSetting,
    });
    const isEmpty = !isLoading && data?.cards.length === 0;
    const pinRegistered = !!data?.isPinRegistered;

    return {
        data,
        isLoading,
        isEmpty,
        pinRegistered,
    };
}

export default useEasyCards;
